import componentsToInititalize from  './component-index.generated'
import Store from 'store'

componentsToInititalize(Store)


